// Кои продукти са редове в листа „Инвентаризация" (и в търсачката/„Целият
// списък" над него): живите + изтритите в организацията (`deleted`), които още
// имат наличност в склада към датата — броенето ги нулира, иначе стоката им
// висеше завинаги — или са в редактирания документ / заредената чернова / в
// приготвените рецепти (иначе записът би изпуснал реда им — BE иска ред за
// всяка съставка). Правилото е `stocktakeProducts`.
import { useCallback, useMemo, useState } from "react";
import type { Product, StockBalance } from "../../../../api/inventory";
import { stocktakeProducts } from "../../components/product/deletedProducts";

// Стабилна празна стойност (нов Map на всеки рендер би чупил memo-то)
const NO_RECIPE_PRODUCTS: ReadonlyMap<number, unknown> = new Map();

export const useStocktakeCountableProducts = (
  products: Product[],
  balanceByProduct: Map<number, StockBalance>,
  // съставките на приготвените рецепти (ключовете — продуктите)
  inRecipesByProduct: ReadonlyMap<number, unknown> = NO_RECIPE_PRODUCTS,
) => {
  const [documentProductIds, setDocumentProductIds] = useState<ReadonlySet<number>>(() => new Set());
  const countableProducts = useMemo(
    () =>
      stocktakeProducts(
        products,
        (productId) => balanceByProduct.get(productId)?.quantity ?? 0,
        (productId) => documentProductIds.has(productId) || inRecipesByProduct.has(productId),
      ),
    [products, balanceByProduct, documentProductIds, inRecipesByProduct],
  );
  // Вика се при зареждане на документ/чернова с id-тата на редовете им
  const rememberDocumentProducts = useCallback(
    (productIds: number[]) => setDocumentProductIds(new Set(productIds)),
    [],
  );
  return { countableProducts, rememberDocumentProducts };
};
